import moment from "moment";

export interface IContractCustomerContact {
    FaxNumber: string | null;
    Mail: string | null;
    MobilePhoneNumber: string;
    PhoneCountry: string | null;
    PhoneNumber: string | null;
    StandarCommMeth: string | null;
}

export interface IContractCustomer {
    Number: string;
    TaxType: string;
    TaxNumber: string;
    NameFirst: string;
    NameLast: string;
    CAE: string;
    Contact?: IContractCustomerContact;
}

export interface INonConnectedProductHeader {
    ProcessType: string;
    ObjectID: string;
    Description: string;
    Status: string;
    StatusDesc: string;
}

export interface IValidityPeriod {
    StartDate: string;
    EndDate: string;
}

export interface IPlafond {
    Currency: string;
    TargetHours: string;
    ActualHours: string;
    TargetAmount: string;
    ActualAmount: string;
    TargetOccurences: string;
    ActualOccurences: string;
    ActualVisits: string;
    TargetVisits: string;
}

export interface IDynamicAttribute {
    AttributeID: string;
    AttributeValue: string;
}

export interface ITax {
    Type: string;
    Value: string;
    Metric: string;
}

export interface INonConnectedProductItem {
    ObjectType: string;
    ItemCategory: string;
    ItemNr: string;
    Type: string;
    ProductID: string;
    Version: string;
    Status: string;
    StatusDesc: string;
    BillingType: string;
    Quantity: string;
    Unit: string;
    ValidityPeriod: IValidityPeriod;

    Tax: ITax;
    DynamicAttribute: IDynamicAttribute[];
    Plafond: IPlafond;
}

export interface INonConnectedProduct {
    Header: INonConnectedProductHeader;
    Item: INonConnectedProductItem[];
}

export interface IContractDetails {
    Customer: IContractCustomer;
    Contracts: any;
    NonConnectedProduct: INonConnectedProduct[];
}

export class FuncionaPlafond {
    totalWithoutTax: number;
    total: number;
    availableWithoutTax: number;
    available: number;
    visits: number;
}

export class Funciona {
    plafond: FuncionaPlafond;
    productId: string;
    validity: IValidityPeriod;
    tax: string;
}

export class ContractDetails implements IContractDetails {
    constructor(public Customer: IContractCustomer, public Contracts: any, public NonConnectedProduct: INonConnectedProduct[]) {}

    public getFunciona(): Funciona {
        const funciona = new Funciona();
        let isDateValid = false;
        if (this.NonConnectedProduct && this.NonConnectedProduct.length) {
            this.NonConnectedProduct.forEach(product => {
                if (product.Header.Status === "E0004" || product.Header.Status === "E0002") {
                    product.Item.forEach(productItem => {
                        if (productItem.Status === "E0004" || productItem.Status === "E0002") {
                            if (productItem.ItemCategory === "ZSC3") {
                                funciona.plafond = new FuncionaPlafond();
                                funciona.plafond.totalWithoutTax = parseFloat(productItem.Plafond.TargetAmount);
                                funciona.plafond.availableWithoutTax =
                                    parseFloat(productItem.Plafond.TargetAmount) - parseFloat(productItem.Plafond.ActualAmount);
                                funciona.plafond.visits = parseInt(productItem.Plafond.ActualVisits, 10);

                                if (!funciona.productId) {
                                    funciona.productId = productItem.ProductID;
                                }
                            }

                            if (productItem.ProductID.includes("CS")) {
                                if (productItem.ValidityPeriod && productItem.ValidityPeriod.EndDate) {
                                    if (moment(productItem.ValidityPeriod.EndDate) >= moment()) {
                                        isDateValid = true;
                                    }
                                }
                            }

                            if (productItem.ItemCategory === "ZSC1") {
                                if (productItem.ProductID.includes("PACK") || productItem.ProductID.includes("FUNCIO")) {
                                    funciona.validity = null;
                                    if (productItem.ValidityPeriod) {
                                        funciona.validity = {
                                            StartDate: productItem.ValidityPeriod.StartDate,
                                            EndDate: productItem.ValidityPeriod.EndDate,
                                        } as IValidityPeriod;
                                    }

                                    funciona.tax = productItem.Tax && productItem.Tax.Value ? productItem.Tax.Value : "0";
                                }
                            }
                        }
                    });
                }
            });
            if (funciona.plafond) {
                funciona.plafond.total = funciona.plafond.totalWithoutTax;
                funciona.plafond.available = funciona.plafond.availableWithoutTax;
            }
        }

        return funciona;
    }

    public getSelfConsumption(): boolean {
        const contract = this.Contracts[0];
        if (!contract || contract.BasicComponent?.length === 0) {
            return false;
        }
        const selfConsumption = contract.BasicComponent.find(i => i.SupplyType === "E" && !!i.SelfConsumption);
        return !!selfConsumption;
    }
}

export class ContractDetailsFactory {
    static create(contractDetails: IContractDetails) {
        const nonConnectedProducts = contractDetails.Contracts.length ? contractDetails.Contracts[0].NonConnectedProduct : [];
        return new ContractDetails(contractDetails.Customer, contractDetails.Contracts, nonConnectedProducts);
    }
}
